import has from 'lodash/has';
import { isAdminAccess, isManagedResource, isReadOnly } from '../../../lib/ACLUtils';
import { getConnectionOrVendorType, isDetectedDataset } from '../../../lib/ResourceUtils';
import { getFirstParentForDataset } from '../../../reducers/selectors';

export const mapStateToProps = (state, ownProps) => {
  const {
    entities: { sources, users, vendors },
    dataSets: { summaryById },
  } = state;

  const { cardData } = ownProps;
  const readOnly = isReadOnly(cardData);
  const isManaged = isManagedResource(cardData);
  const adminAccess = isAdminAccess(cardData);
  let connectionOrVendorType = null;

  const owner = has(cardData, 'owner') && has(users, cardData.owner) ? users[cardData.owner] : null;

  const isDetected = isDetectedDataset(cardData);
  let source = null,
    parentDataSet = null;

  if (isDetected === true) {
    source = cardData ? sources[cardData?.data_source_id] : null;

    connectionOrVendorType = source
      ? getConnectionOrVendorType(source, vendors, 'source_type', 'vendor_id')
      : null;
  } else {
    parentDataSet = getFirstParentForDataset(state, ownProps);
  }

  return {
    readOnly,
    isManaged,
    adminAccess,
    owner,
    isDetected,
    source,
    connectionOrVendorType,
    parentDataSet,
    summaryData: cardData && has(summaryById, cardData.id) ? summaryById[cardData.id] : null,
  };
};
